import axios from "axios"
import { baseUrl } from "./BaseUrl";
export const GetMethod = (routeName, auth) => {
    var headers = [];
    if (!auth) {
      headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: auth,
      };
    }
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios
        .get(`${baseUrl}/${routeName}`, {
          headers: headers,
        })
        const jsonResponse = await res.data;
        resolve(jsonResponse);
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  };